<template>
  <a-config-provider :theme="antdTheme">
    <router-view />
  </a-config-provider>
</template>

<script setup>
import { computed, onUnmounted, ref } from 'vue'
import { theme as antdTokens } from 'ant-design-vue'
import { isDark, onThemeChange } from '@/utils/theme'

const dark = ref(isDark())
const off = onThemeChange((theme) => {
  dark.value = theme === 'dark'
})
onUnmounted(off)

const antdTheme = computed(() => ({
  algorithm: dark.value ? antdTokens.darkAlgorithm : antdTokens.defaultAlgorithm,
}))
</script>

<style>
html, body, #app { 
  height: 100%; 
  margin: 0;
  padding: 0;
}
</style>
